<template>
    <el-button :type="type"
               :size="size"
               @click="handleClick"
               :disabled="isDisabled">
        <slot v-if="!count"></slot>
        <span v-else>
            {{description}} {{count}}秒
        </span>
    </el-button>
</template>

<script>
export default {
    data () {
        return {
            count: 0,
            timer: 0
        };
    },
    props: {
        size: String,
        type: String,
        time: Number,
        disabled: Boolean,
        description: String
    },
    computed: {
        isDisabled () {
            return this.disabled || !!this.count;
        }
    },
    methods: {
        handleClick (evt) {
            if (this.time) {
                this.count = this.time;
                this.handleProgress();
            }
            this.$emit('click', evt);
        },

        handleProgress () {
            this.timer = setInterval(() => {
                if (this.count) {
                    this.count--;
                } else {
                    clearInterval(this.timer);
                }
            }, 1000);
        }
    },
    beforeDestroy () {
        clearInterval(this.timer);
    },
};
</script>
